module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo-container"
  }, [(_vm.configure === true) ? _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.loginlogo.configureValue
    }
  }) : _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('el-menu', {
    staticClass: "menu-yx",
    attrs: {
      "collapse": _vm.isCollapse,
      "default-active": _vm.$route.path,
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": ""
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c34adcc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 562
// module chunks = 313